import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Button, 
  List,
  ListItem,
  ListItemText
} from '@mui/material';
import { School as SchoolIcon } from '@mui/icons-material';

interface CourseResource {
  title: string;
  description: string;
  type: string;
}

interface CourseBlockProps {
  title?: string;
  description?: string;
  resources?: CourseResource[];
  buttonText?: string;
  onStartCourse?: () => void;
}

const CourseBlock: React.FC<CourseBlockProps> = ({
  title = 'Курс',
  description = 'Пройдите наш специальный курс, чтобы научиться эффективно справляться с проблемой.',
  resources = [],
  buttonText = 'Начать курс',
  onStartCourse
}) => {
  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <SchoolIcon color="primary" />
          {title}
        </Typography>
        <Typography paragraph>
          {description}
        </Typography>
        {resources.length > 0 && (
          <List>
            {resources.map((resource, index) => (
              <ListItem key={index}>
                <ListItemText 
                  primary={resource.title}
                  secondary={resource.description}
                />
              </ListItem>
            ))}
          </List>
        )}
        <Button 
          variant="outlined" 
          color="primary"
          size="large"
          fullWidth
          sx={{ mt: 2 }}
          onClick={onStartCourse}
        >
          {buttonText}
        </Button>
      </CardContent>
    </Card>
  );
};

export default CourseBlock; 